import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const UPDATED = "June 2026";

function Sec({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="font-heading font-bold text-lg text-foreground">{title}</h2>
      <div className="text-sm text-muted-foreground leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="max-w-3xl mx-auto space-y-8">
      <div className="space-y-2">
        <div className="w-12 h-12 rounded-2xl bg-red-600/15 grid place-items-center">
          <ShieldCheck className="w-6 h-6 text-red-600" />
        </div>
        <h1 className="font-heading font-extrabold text-3xl">Privacy Policy</h1>
        <p className="text-xs text-muted-foreground">Last updated: {UPDATED}</p>
      </div>

      <Sec title="1. Information we collect">
        <p>When you create an account we collect your name, email address, and a securely hashed password. If you sign in with Google, we receive your basic profile (name, email) from the managed sign-in provider. We also store data you create in the app: watchlists, portfolio holdings, price alerts, articles and notes, and Practice Trading activity.</p>
      </Sec>

      <Sec title="2. How we use your information">
        <p>We use your information to provide and operate the Service — authenticating you, saving your watchlists and portfolios, sending emails you enable (welcome, price alerts, digests, newsletters), and generating AI insights you request.</p>
      </Sec>

      <Sec title="3. Third-party services">
        <p>We rely on trusted third parties to run the Service: market data providers (including Yahoo Finance), AI model providers for analysis and drafting, and an email delivery provider for transactional emails. Data shared with these providers is limited to what is needed to deliver the relevant feature.</p>
      </Sec>

      <Sec title="4. Cookies and storage">
        <p>We use browser storage to keep you signed in and to remember preferences (such as your theme). We do not sell your personal information.</p>
      </Sec>

      <Sec title="5. Data security">
        <p>Passwords are stored hashed, and access to your data is scoped to your account. No method of transmission or storage is completely secure, but we take reasonable measures to protect your information.</p>
      </Sec>

      <Sec title="6. Email preferences">
        <p>Transactional and marketing emails (like the newsletter) are optional and controlled by your settings. You can disable them at any time.</p>
      </Sec>

      <Sec title="7. Data retention and deletion">
        <p>We retain your data while your account is active. You may request deletion of your account and associated data by contacting us.</p>
      </Sec>

      <Sec title="8. Children">
        <p>The Service is not directed to children under 13 (or the minimum age required in your jurisdiction), and we do not knowingly collect their information.</p>
      </Sec>

      <Sec title="9. Changes">
        <p>We may update this Privacy Policy periodically. Material changes will be reflected by the "Last updated" date above.</p>
      </Sec>

      <Sec title="10. Contact">
        <p>Questions about your privacy? Contact us at <span className="text-foreground">privacy@stewartcapfinance.com</span>.</p>
      </Sec>

      <div className="pt-4 border-t border-border text-sm">
        <Link to="/terms" data-testid="privacy-to-terms" className="text-red-600 hover:underline">Read our Terms of Service →</Link>
      </div>
    </div>
  );
}
